import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CollapseIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" fill="none" title={t`Collapse`} {...props}>
    <Path
      d="M3 9h6V3m12 6h-6V3M9 21v-6H3m12 6v-6h6"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
